// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import { promoBoxStyles } from "@rpsc/App/Components/OnePageCheckout/PromoBox";
import IconClose from "@rpsc/XDL/Icons/IconClose";
import { color, createLinkIconStyles, xScreen } from "@rpsc/XDL/Utilities";

import { css } from "styled-components";

promoBoxStyles.success = {
    color: "success",
    size: 12,
    lineHeight: "14px",
};

promoBoxStyles.enterPromotionCodeContainer = {
    css: css`
        display: flex;
        gap: 8px;
        align-items: flex-end;
    `,
};

promoBoxStyles.title = {
    variant: "h5",
    forwardAs: "p",
    css: css`
        margin-bottom: 12px;
    `,
};

promoBoxStyles.enterPromotionCodeApplyButton = {
    sizeVariant: "medium",
    css: css`
        margin-top: 24px;
        height: 33px;
        padding: 0 30px;
    `,
};

promoBoxStyles.enterPromotionCodeTextField = {
    mergeCss: true,
    cssOverrides: {
        formInputWrapper: css`
            &&& {
                min-width: 195px;
                ${xScreen("lte", "md")} {
                    min-width: auto;
                }
            }
        `,
    },
};

promoBoxStyles.promotionsContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        padding-top: 16px;
        & ${StyledButton} {
            width: fit-content;
        }
        & > div {
            width: fit-content;
        }
    `,
};
promoBoxStyles.removeAll = {
    ...createLinkIconStyles(IconClose, {
        css: css`
            ${IconWrapper}, svg {
                width: 8px;
                height: 13px;
            }
        `,
    }),
};

promoBoxStyles.promoName = {
    size: 12,
    lineHeight: "13px",
    color: "secondary",
    weight: "bold",
};

promoBoxStyles.promoLineContainer = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 12px;
        gap: 12px;
        margin-bottom: 8px;
        ${IconWrapper}, svg {
            width: 12px;
            height: 13px;
            color: ${color("secondary")};
        }

        &:last-child {
            margin-bottom: 0;
        }
    `,
};
